// src/components/Layout.js

import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import ChatWidget from './ChatWidget'; // ✅ import the widget

function Layout() {
  return (
    <>
      {/* ========== STYLES FOR DONATE BUTTON ========== */}
      <style>
        {`
          .donate-btn {
            background-color: #c8102e; /* BFS red */
            color: #fff !important;
            border-radius: 9999px; /* pill shape */
            padding: 0.5rem 1rem;
            transition: background-color 0.2s ease;
            border: none;
            display: inline-block; 
            text-align: center;
            text-decoration: none;
          }
          .donate-btn:hover {
            background-color: #e01a3b; /* lighter red on hover */
            color: #fff !important;
          }
        `}
      </style>

      {/* ========== GLOBAL HEADER / NAVBAR ========== */}
      <Navbar bg="white" expand="md" sticky="top" className="shadow-sm">
        <Container>
          <img
            src="http://benignfasciculationsyndrome.org/assets/uploads/logo.png"
            alt="BFS Logo"
            style={{ height: '40px' }}
          />
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/" className="me-3 fw-semibold" style={{ color: '#333' }}>
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/about" className="me-3 fw-semibold" style={{ color: '#333' }}>
                About
              </Nav.Link>

              <Nav.Link as={Link} to="/blog" className="me-3 fw-semibold" style={{ color: '#333' }}>
                Blog
              </Nav.Link>
              
              <Nav.Link as={Link} to="/resources" className="me-3 fw-semibold" style={{ color: '#333' }}>
                Resources
              </Nav.Link>
              <Nav.Link as={Link} to="/contact" className="me-3 fw-semibold" style={{ color: '#333' }}>
                Contact
              </Nav.Link>

              {/* Donate link as a custom pill-shaped button */}
              <Nav.Link as={Link} to="/donate" className="fw-semibold donate-btn">
                Donate
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* ========== MAIN CONTENT RENDERED HERE ========== */}
      <Outlet />

      {/* ========== FOOTER ========== */}
      <div style={{ backgroundColor: '#222', color: '#fff', padding: '2rem 0', textAlign: 'center' }}>
        <Container>
          <p className="mb-1" style={{ fontSize: '1rem' }}>
            © {new Date().getFullYear()} BFS Organization. All rights reserved.
          </p>
          <p style={{ opacity: 0.8, fontSize: '1rem' }}>
            <em>Not medical advice. Always consult with a healthcare professional.</em>
          </p>
        </Container>
      </div>

      {/* ✅ Floating Chat Widget (always available) */}
      <ChatWidget />
    </>
  );
}

export default Layout;
